/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(function() {
  $.fn.updateErrorMessage = function(message) {
    var error_jq = this.next('.field-error'); // regular element
    if (error_jq.length === 0) { error_jq = this.parent().next('.field-error'); } // .select element
    if (error_jq.length !== 0) { return error_jq.html(message + '<div class="arrow"></div>'); }
  };

  return $('form#new_dispute').bind('ajax:error', function() {
    // Show error message for different element
    $('#dispute_other_desired_outcome').updateErrorMessage("What outcome are you hoping for? Can\'t be blank");
    // Remove full stop
    return $('#dispute_problem_description').updateErrorMessage("Tell us about your problem can't be blank");
  });
});
